import { Formik } from 'formik';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Input } from '../../../../shared/Forms';
import styles from './TransportEditModal.module.scss';
import { deleteSMCCarsRequest, getSMCCarsRequest, postAddSMCCarsRequest } from '../services/actions';
import validateEditCarModal from './schema';

type Props = {
  show?: boolean;
  data: any;
  onClose?: () => void;
};

export const TransportEditModal: React.FC<Props> = ({ show, onClose, data }) => {
  const dispatch = useDispatch();
  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onClick={(e: any) => e.stopPropagation()}
    >
      <Modal.Header className="border-bottom-0">
        <h4>Власний транспорт</h4>
      </Modal.Header>
      <Formik
        initialValues={data} // @ts-ignore
        onSubmit={(values) => {
          dispatch(postAddSMCCarsRequest({ licensePlate: values.number, description: values.description }));
          if (onClose) {
            onClose();
          }
          setTimeout(() => dispatch(getSMCCarsRequest()), 1000);
        }}
        validationSchema={validateEditCarModal}
      >
        {({ handleSubmit, handleChange, handleBlur, values }) => (
          <form onSubmit={handleSubmit}>
            <Modal.Body className="d-flex align-items-center flex-column px-4">
              <div className={styles.wrapper}>
                <span>
                  Держномер <em className="text-danger mr-1">*</em>:
                </span>
                <Input
                  name="number"
                  value={values?.number}
                  label=""
                  onLine
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className={styles.wrapper}>
                <span>
                  Тип або марка <em className="text-danger mr-1">*</em>:
                </span>
                <Input
                  name="description"
                  value={values.description}
                  label=""
                  onLine
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-around border-top-0 mt-2 mb-4">
              <Button variant="outline-secondary" onClick={onClose} className="py-2 text-uppercase w-140 \">
                Назад
              </Button>
              <Button
                onClick={() => {
                  dispatch(deleteSMCCarsRequest(values.id));
                  if (onClose) {
                    onClose();
                  }
                  setTimeout(() => dispatch(getSMCCarsRequest()), 1000);
                }}
                variant="outline-secondary"
                id="onVerifyCode"
                className="px-2 py-2 text-uppercase w-140"
              >
                Видалити з списку
              </Button>
            </Modal.Footer>
          </form>
        )}
      </Formik>
    </Modal>
  );
};
